import {
  RequestDetailsHeaderStyle,
  RequestDetailsTitle,
  RequestDetailsTitleContainer,
  ArrowLeft,
} from './styles/RequestDetailsHeader.styled';
import { RequestIcon } from '../../RequestsWidget/RequestIcon';

interface RequestDetailsHeaderProps {
  vacationStatus: string | number;
  hideRequestPopup: () => void;
}

export const RequestDetailsHeader = ({
  vacationStatus,
  hideRequestPopup,
}: RequestDetailsHeaderProps) => {
  return (
    <RequestDetailsHeaderStyle>
      <RequestDetailsTitleContainer>
        <ArrowLeft onClick={hideRequestPopup} />
        <RequestIcon requestStatus={vacationStatus} size={24} />
        <RequestDetailsTitle>Request Details</RequestDetailsTitle>
      </RequestDetailsTitleContainer>
    </RequestDetailsHeaderStyle>
  );
};
